export type CompanionDestinationId =
  | "today"
  | "plan"
  | "explore"
  | "people"
  | "you";

export type CompanionDestination = {
  id: CompanionDestinationId;
  href: string;
  label: "Today" | "Plan" | "Explore" | "People" | "You";
};

export const COMPANION_DESTINATIONS: readonly CompanionDestination[] = [
  { id: "today", href: "/companion", label: "Today" },
  { id: "plan", href: "/companion/plan", label: "Plan" },
  { id: "explore", href: "/companion/explore", label: "Explore" },
  { id: "people", href: "/companion/people", label: "People" },
  { id: "you", href: "/companion/you", label: "You" },
] as const;

const DESTINATION_PREFIXES: Record<CompanionDestinationId, readonly string[]> = {
  today: ["/companion"],
  plan: ["/companion/plan", "/companion/season"],
  explore: ["/companion/explore", "/companion/track"],
  people: ["/companion/people", "/companion/leaderboards", "/companion/challenges", "/companion/piste-times"],
  you: [
    "/companion/you",
    "/companion/record",
    "/companion/history",
    "/companion/story",
    "/companion/passport",
    "/companion/wrapped",
    "/companion/settings",
    "/companion/calls",
    "/companion/briefings",
    "/companion/offline",
    "/companion/notifications",
  ],
};

export function companionDestinationForPathname(
  pathname: string,
): CompanionDestinationId | null {
  if (pathname === "/companion") return "today";

  for (const destination of COMPANION_DESTINATIONS.slice(1)) {
    if (
      DESTINATION_PREFIXES[destination.id].some(
        (prefix) => pathname === prefix || pathname.startsWith(`${prefix}/`),
      )
    ) {
      return destination.id;
    }
  }

  return null;
}
